import { popularTVShows } from '@/mocks/homeData';
import { useNavigate } from 'react-router-dom';

export default function TVSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门剧集 <span className="text-accent-600">推荐</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">高分热门电视剧，追剧达人的不二之选</p>
          </div>
          <button
            onClick={() => {
              navigate('/category/kehuan');
              window.scrollTo({ top: 0, behavior: 'instant' });
            }}
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
          >
            更多剧集 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {popularTVShows.map((show) => (
            <article
              key={show.id}
              onClick={() => {
                navigate(`/article/${show.id}`);
                window.scrollTo({ top: 0, behavior: 'instant' });
              }}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[2/3]">
                <img
                  src={show.image}
                  alt={`${show.title} - ${show.titleEn}`}
                  title={`${show.title} ${show.episodes}集`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-semibold">
                    {show.quality}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <div className="text-xs text-background-200 mb-1">{show.episodes} 集全</div>
                  <button className="w-full py-2 rounded-lg bg-accent-500 text-background-50 text-xs font-semibold flex items-center justify-center gap-1 whitespace-nowrap">
                    <i className="ri-play-fill"></i> 开始追剧
                  </button>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors truncate">
                {show.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-accent-500 font-semibold">{show.rating}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span className="text-xs text-foreground-500">{show.category}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <button
            onClick={() => {
              navigate('/category/kehuan');
              window.scrollTo({ top: 0, behavior: 'instant' });
            }}
            className="px-6 py-2.5 rounded-full border border-accent-300 text-sm font-medium text-accent-600 hover:bg-accent-50 transition-colors whitespace-nowrap"
          >
            更多剧集
          </button>
        </div>
      </div>
    </section>
  );
}